import { render, staticRenderFns } from "./AdminPomotion.vue?vue&type=template&id=3690eb99"
import script from "./AdminPomotion.vue?vue&type=script&lang=js"
export * from "./AdminPomotion.vue?vue&type=script&lang=js"
import style0 from "./AdminPomotion.vue?vue&type=style&index=0&id=3690eb99&prod&lang=scss"
import style1 from "./AdminPomotion.vue?vue&type=style&index=1&id=3690eb99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports